import React, { useState, useEffect } from 'react';
import { getProfilePictureUrl } from '../firebasehelpers/getProfilePictureUrl';
import { auth } from '../Firebase/FirebaseConfig';
import { signOut } from 'firebase/auth';
import '../styles/UserProfile.css'; // Import the CSS file for UserProfile

const UserProfile = ({ userEmail }) => {
  const [profilePicUrl, setProfilePicUrl] = useState('');

  useEffect(() => {
    getProfilePictureUrl(userEmail).then(url => {
      setProfilePicUrl(url);
    });
  }, [userEmail]);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      console.log('Logged out successfully');
      // Optionally, redirect to login page or update UI state
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  return (
    <div className="user-profile">
      {profilePicUrl 
        ? <img src={profilePicUrl} alt="Profile" className="profile-pic" />
        : <p>No profile picture</p>}
        <button onClick={handleLogout} className="logout-button">Logout</button>
    </div>
  );
};

export default UserProfile;
